// useSessionUI.ts
import { ref, watch } from 'vue'
import { log } from '../../utils/logger'

// ****************************************************************************
// SessionStorage *************************************************************
// ****************************************************************************
interface SessionState {
    sliderControl: boolean
    isF1: boolean
    isF2: boolean
    isF3: boolean
}

const KEY_SESSION = 'SessionUI'
const SLIDER_CONTROL = false // default no display -/+

function loadState(): SessionState {
    const raw = sessionStorage.getItem(KEY_SESSION)
    if (!raw) {
        return {
            sliderControl: SLIDER_CONTROL,
            isF1: false,
            isF2: false,
            isF3: false
        }
    }
    try {
        return JSON.parse(raw)
    } catch {
        return {
            sliderControl: SLIDER_CONTROL,
            isF1: false,
            isF2: false,
            isF3: false
        }
    }
}

const state = loadState()
const sliderControl = ref<boolean>(state.sliderControl)
const isF1 = ref<boolean>(state.isF1)
const isF2 = ref<boolean>(state.isF2)
const isF3 = ref<boolean>(state.isF3)

// 3. Guardar automáticamente cuando algo cambie
watch(
    [sliderControl, isF1, isF2, isF3],
    () => {
        const data: SessionState = {
            sliderControl: sliderControl.value,
            isF1: isF1.value,
            isF2: isF2.value,
            isF3: isF3.value
        }
        sessionStorage.setItem(KEY_SESSION, JSON.stringify(data))
    },
    { deep: true }
)

// ****************************************************************************
// useSessionUI ***************************************************************
// ****************************************************************************
export function useSessionUI() {
    return {
        // stored in sessionStorage
        sliderControl,
        isF1,
        isF2,
        isF3
    }
}
